import { mapGetters } from "vuex";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

const PanoViewerMixin = {
	components: {},
	computed: {
		...mapGetters(["cuboids"]),
	},
	data: () => ({
		containerHeight: 0,
		containerWidth: 0,
		containerId: "PanoCanvas",
		showPoweredByFoyrLoader: false,
		show360InteractionOverlay: false,
		textureLoadCount: 0,
		initialAutoRotateSpeed: 2,
		finalAutoRotateSpeed: 2,
	}),
	methods: {
		setContainerDimensions() {
			this.containerHeight = window.innerHeight;
			this.containerWidth = window.innerWidth;
		},
		init() {
			// reset texure load
			this.textureLoadCount = 0;
			this.showPoweredByFoyrLoader = true;

			const container = document.getElementById(this.containerId);
			this.setContainerDimensions();

			this.renderer = new THREE.WebGLRenderer();
			this.renderer.setPixelRatio(window.devicePixelRatio);
			this.renderer.setSize(this.containerWidth, this.containerHeight);
			container.appendChild(this.renderer.domElement);

			// add event Listener
			container.addEventListener("pointerdown", this.onPointerDown);

			this.scene = new THREE.Scene();

			this.camera = new THREE.PerspectiveCamera(
				60,
				this.containerWidth / this.containerHeight,
				0.1,
				100
			);
			this.camera.position.z = 0.01;

			this.controls = new OrbitControls(
				this.camera,
				this.renderer.domElement
			);
			this.controls.enableZoom = false;
			this.controls.enablePan = false;
			this.controls.enableDamping = true;
			this.controls.rotateSpeed = -0.25;

			this.materials = [];

			for (let i = 0; i < 6; i++) {
				this.materials.push(
					new THREE.MeshBasicMaterial({
						side: THREE.DoubleSide,
					})
				);
			}

			const skyBox = new THREE.Mesh(
				new THREE.BoxGeometry(1, 1, 1),
				this.materials
			);
			skyBox.geometry.scale(1, 1, 1);
			this.scene.add(skyBox);

			window.addEventListener("resize", this.onWindowResize);
		},
		updateTexture() {
			const textures = this.getTexturesFromAtlasFile(this.cuboids[0], 6);
			for (let i = 0; i < this.materials.length; i++) {
				this.materials[i].map = textures[i];
				this.materials[i].needsUpdate = true;
			}
		},
		getTexturesFromAtlasFile(atlasImgUrl, tilesNum) {
			const textures = [];
			for (let i = 0; i < tilesNum; i++) {
				textures[i] = new THREE.Texture();
			}

			new THREE.ImageLoader().load(atlasImgUrl, (image) => {
				let canvas, context;
				const tileWidth = image.height;

				for (let i = 0; i < textures.length; i++) {
					canvas = document.createElement("canvas");
					context = canvas.getContext("2d");
					canvas.height = tileWidth;
					canvas.width = tileWidth;
					context.drawImage(
						image,
						tileWidth * i,
						0,
						tileWidth,
						tileWidth,
						0,
						0,
						tileWidth,
						tileWidth
					);
					textures[i].image = canvas;
					textures[i].needsUpdate = true;

					this.textureLoadCount++;
					if (this.textureLoadCount == textures.length - 1) {
						this.onPanoramaLoaded();
					}
				}
			});
			return textures;
		},
		onWindowResize() {
			this.setContainerDimensions();
			this.camera.aspect = this.containerWidth / this.containerHeight;
			this.camera.updateProjectionMatrix();
			this.renderer.setSize(this.containerWidth, this.containerHeight);
		},
		animate() {
			requestAnimationFrame(this.animate);
			this.controls.update(); // required when damping is enabled
			this.renderer.render(this.scene, this.camera);
		},
		onPointerDown(event) {
			if (event.isPrimary === false) return;

			this.controls.autoRotate = false;
			this.controls.autoRotateSpeed = this.finalAutoRotateSpeed;
		},
		onPanoramaLoaded() {
			this.showPoweredByFoyrLoader = false;

			this.controls.autoRotate = true;
			this.controls.autoRotateSpeed = this.initialAutoRotateSpeed;
		},
	},
	destroyed() {
		window.removeEventListener("resize", this.onWindowResize);
	},
};

export default PanoViewerMixin;
